"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateResponse = exports.ValidateRequest = exports.SubscribeResponse = exports.SubscribeRequest = exports.SubmitResponse = exports.SubmitRequest = exports.RecordResponse = exports.QueryRequest = exports.PrivateSequenceResponse = exports.PrivateSequenceRequest = exports.NodeInfoResponse = exports.NodeInfoRequest = exports.NetworkStatusResponse = exports.NetworkStatusRequest = exports.FindServiceResponse = exports.FindServiceRequest = exports.FaucetResponse = exports.FaucetRequest = exports.EventMessage = exports.ErrorResponse = exports.ConsensusStatusResponse = exports.ConsensusStatusRequest = void 0;
const api = __importStar(require("."));
const url_1 = require("../address/url");
const encoding_1 = require("../encoding");
const errors2 = __importStar(require("../errors"));
const messaging = __importStar(require("../messaging"));
const msg_1 = require("./msg");
const p2p = __importStar(require("./p2p"));
class ConsensusStatusRequest {
    constructor(args) {
        this.type = msg_1.MessageType.ConsensusStatusRequest;
        this.nodeID = args.nodeID == undefined ? undefined : args.nodeID;
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.includePeers = args.includePeers == undefined ? undefined : args.includePeers;
        this.includeAccumulate =
            args.includeAccumulate == undefined ? undefined : args.includeAccumulate;
    }
    copy() {
        return new ConsensusStatusRequest(this.asObject());
    }
    asObject() {
        return {
            type: "consensusStatusRequest",
            nodeID: this.nodeID && this.nodeID,
            partition: this.partition && this.partition,
            includePeers: this.includePeers && this.includePeers,
            includeAccumulate: this.includeAccumulate && this.includeAccumulate,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], ConsensusStatusRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).string
], ConsensusStatusRequest.prototype, "nodeID", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 2).string
], ConsensusStatusRequest.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).bool
], ConsensusStatusRequest.prototype, "includePeers", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).bool
], ConsensusStatusRequest.prototype, "includeAccumulate", void 0);
exports.ConsensusStatusRequest = ConsensusStatusRequest;
class ConsensusStatusResponse {
    constructor(args) {
        this.type = msg_1.MessageType.ConsensusStatusResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof api.ConsensusStatus
                    ? args.value
                    : new api.ConsensusStatus(args.value);
    }
    copy() {
        return new ConsensusStatusResponse(this.asObject());
    }
    asObject() {
        return {
            type: "consensusStatusResponse",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], ConsensusStatusResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], ConsensusStatusResponse.prototype, "value", void 0);
exports.ConsensusStatusResponse = ConsensusStatusResponse;
class ErrorResponse {
    constructor(args) {
        this.type = msg_1.MessageType.ErrorResponse;
        this.error =
            args.error == undefined
                ? undefined
                : args.error instanceof errors2.Error
                    ? args.error
                    : new errors2.Error(args.error);
    }
    copy() {
        return new ErrorResponse(this.asObject());
    }
    asObject() {
        return {
            type: "errorResponse",
            error: this.error && this.error.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], ErrorResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], ErrorResponse.prototype, "error", void 0);
exports.ErrorResponse = ErrorResponse;
class EventMessage {
    constructor(args) {
        this.type = msg_1.MessageType.Event;
        this.value =
            args.value == undefined
                ? undefined
                : args.value.map((v) => (v == undefined ? undefined : api.Event.fromObject(v)));
    }
    copy() {
        return new EventMessage(this.asObject());
    }
    asObject() {
        return {
            type: "event",
            value: this.value && this.value?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], EventMessage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.keepEmpty.union
], EventMessage.prototype, "value", void 0);
exports.EventMessage = EventMessage;
class FaucetRequest {
    constructor(args) {
        this.type = msg_1.MessageType.FaucetRequest;
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
        this.token = args.token == undefined ? undefined : url_1.AccumulateURL.parse(args.token);
    }
    copy() {
        return new FaucetRequest(this.asObject());
    }
    asObject() {
        return {
            type: "faucetRequest",
            account: this.account && this.account.toString(),
            token: this.token && this.token.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], FaucetRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], FaucetRequest.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).url
], FaucetRequest.prototype, "token", void 0);
exports.FaucetRequest = FaucetRequest;
class FaucetResponse {
    constructor(args) {
        this.type = msg_1.MessageType.FaucetResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof api.Submission
                    ? args.value
                    : new api.Submission(args.value);
    }
    copy() {
        return new FaucetResponse(this.asObject());
    }
    asObject() {
        return {
            type: "faucetResponse",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], FaucetResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], FaucetResponse.prototype, "value", void 0);
exports.FaucetResponse = FaucetResponse;
class FindServiceRequest {
    constructor(args) {
        this.type = msg_1.MessageType.FindServiceRequest;
        this.network = args.network == undefined ? undefined : args.network;
        this.service =
            args.service == undefined
                ? undefined
                : args.service instanceof api.ServiceAddress
                    ? args.service
                    : new api.ServiceAddress(args.service);
        this.known = args.known == undefined ? undefined : args.known;
        this.timeout = args.timeout == undefined ? undefined : args.timeout;
    }
    copy() {
        return new FindServiceRequest(this.asObject());
    }
    asObject() {
        return {
            type: "findServiceRequest",
            network: this.network && this.network,
            service: this.service && this.service.asObject(),
            known: this.known && this.known,
            timeout: this.timeout && this.timeout,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], FindServiceRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).string
], FindServiceRequest.prototype, "network", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 2).reference
], FindServiceRequest.prototype, "service", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).bool
], FindServiceRequest.prototype, "known", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).duration
], FindServiceRequest.prototype, "timeout", void 0);
exports.FindServiceRequest = FindServiceRequest;
class FindServiceResponse {
    constructor(args) {
        this.type = msg_1.MessageType.FindServiceResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value.map((v) => v == undefined
                    ? undefined
                    : v instanceof api.FindServiceResult
                        ? v
                        : new api.FindServiceResult(v));
    }
    copy() {
        return new FindServiceResponse(this.asObject());
    }
    asObject() {
        return {
            type: "findServiceResponse",
            value: this.value && this.value?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], FindServiceResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.keepEmpty.reference
], FindServiceResponse.prototype, "value", void 0);
exports.FindServiceResponse = FindServiceResponse;
class NetworkStatusRequest {
    constructor(args) {
        this.type = msg_1.MessageType.NetworkStatusRequest;
        this.partition = args.partition == undefined ? undefined : args.partition;
    }
    copy() {
        return new NetworkStatusRequest(this.asObject());
    }
    asObject() {
        return {
            type: "networkStatusRequest",
            partition: this.partition && this.partition,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], NetworkStatusRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).string
], NetworkStatusRequest.prototype, "partition", void 0);
exports.NetworkStatusRequest = NetworkStatusRequest;
class NetworkStatusResponse {
    constructor(args) {
        this.type = msg_1.MessageType.NetworkStatusResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof api.NetworkStatus
                    ? args.value
                    : new api.NetworkStatus(args.value);
    }
    copy() {
        return new NetworkStatusResponse(this.asObject());
    }
    asObject() {
        return {
            type: "networkStatusResponse",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], NetworkStatusResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], NetworkStatusResponse.prototype, "value", void 0);
exports.NetworkStatusResponse = NetworkStatusResponse;
class NodeInfoRequest {
    constructor(args) {
        this.type = msg_1.MessageType.NodeInfoRequest;
        this.peerID = args.peerID == undefined ? undefined : p2p.PeerID.fromObject(args.peerID);
    }
    copy() {
        return new NodeInfoRequest(this.asObject());
    }
    asObject() {
        return {
            type: "nodeInfoRequest",
            peerID: this.peerID && this.peerID.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], NodeInfoRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).union
], NodeInfoRequest.prototype, "peerID", void 0);
exports.NodeInfoRequest = NodeInfoRequest;
class NodeInfoResponse {
    constructor(args) {
        this.type = msg_1.MessageType.NodeInfoResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof api.NodeInfo
                    ? args.value
                    : new api.NodeInfo(args.value);
    }
    copy() {
        return new NodeInfoResponse(this.asObject());
    }
    asObject() {
        return {
            type: "nodeInfoResponse",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], NodeInfoResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], NodeInfoResponse.prototype, "value", void 0);
exports.NodeInfoResponse = NodeInfoResponse;
class PrivateSequenceRequest {
    constructor(args) {
        this.type = msg_1.MessageType.PrivateSequenceRequest;
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.destination = args.destination == undefined ? undefined : url_1.AccumulateURL.parse(args.destination);
        this.sequenceNumber = args.sequenceNumber == undefined ? undefined : args.sequenceNumber;
        this.nodeID = args.nodeID == undefined ? undefined : p2p.PeerID.fromObject(args.nodeID);
    }
    copy() {
        return new PrivateSequenceRequest(this.asObject());
    }
    asObject() {
        return {
            type: "privateSequenceRequest",
            source: this.source && this.source.toString(),
            destination: this.destination && this.destination.toString(),
            sequenceNumber: this.sequenceNumber && this.sequenceNumber,
            nodeID: this.nodeID && this.nodeID.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], PrivateSequenceRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], PrivateSequenceRequest.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], PrivateSequenceRequest.prototype, "destination", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], PrivateSequenceRequest.prototype, "sequenceNumber", void 0);
__decorate([
    encoding_1.encodeAs.field(5, 1).union
], PrivateSequenceRequest.prototype, "nodeID", void 0);
exports.PrivateSequenceRequest = PrivateSequenceRequest;
class PrivateSequenceResponse {
    constructor(args) {
        this.type = msg_1.MessageType.PrivateSequenceResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof (api.MessageRecord)
                    ? args.value
                    : new api.MessageRecord(args.value);
    }
    copy() {
        return new PrivateSequenceResponse(this.asObject());
    }
    asObject() {
        return {
            type: "privateSequenceResponse",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], PrivateSequenceResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], PrivateSequenceResponse.prototype, "value", void 0);
exports.PrivateSequenceResponse = PrivateSequenceResponse;
class QueryRequest {
    constructor(args) {
        this.type = msg_1.MessageType.QueryRequest;
        this.scope = args.scope == undefined ? undefined : url_1.AccumulateURL.parse(args.scope);
        this.query = args.query == undefined ? undefined : api.Query.fromObject(args.query);
    }
    copy() {
        return new QueryRequest(this.asObject());
    }
    asObject() {
        return {
            type: "queryRequest",
            scope: this.scope && this.scope.toString(),
            query: this.query && this.query.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], QueryRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], QueryRequest.prototype, "scope", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], QueryRequest.prototype, "query", void 0);
exports.QueryRequest = QueryRequest;
class RecordResponse {
    constructor(args) {
        this.type = msg_1.MessageType.RecordResponse;
        this.value = args.value == undefined ? undefined : api.Record.fromObject(args.value);
    }
    copy() {
        return new RecordResponse(this.asObject());
    }
    asObject() {
        return {
            type: "recordResponse",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], RecordResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], RecordResponse.prototype, "value", void 0);
exports.RecordResponse = RecordResponse;
class SubmitRequest {
    constructor(args) {
        this.type = msg_1.MessageType.SubmitRequest;
        this.envelope =
            args.envelope == undefined
                ? undefined
                : args.envelope instanceof messaging.Envelope
                    ? args.envelope
                    : new messaging.Envelope(args.envelope);
        this.verify = args.verify == undefined ? undefined : args.verify;
        this.wait = args.wait == undefined ? undefined : args.wait;
    }
    copy() {
        return new SubmitRequest(this.asObject());
    }
    asObject() {
        return {
            type: "submitRequest",
            envelope: this.envelope && this.envelope.asObject(),
            verify: this.verify && this.verify,
            wait: this.wait && this.wait,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], SubmitRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], SubmitRequest.prototype, "envelope", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).bool
], SubmitRequest.prototype, "verify", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 2).bool
], SubmitRequest.prototype, "wait", void 0);
exports.SubmitRequest = SubmitRequest;
class SubmitResponse {
    constructor(args) {
        this.type = msg_1.MessageType.SubmitResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value.map((v) => v == undefined ? undefined : v instanceof api.Submission ? v : new api.Submission(v));
    }
    copy() {
        return new SubmitResponse(this.asObject());
    }
    asObject() {
        return {
            type: "submitResponse",
            value: this.value && this.value?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], SubmitResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.keepEmpty.reference
], SubmitResponse.prototype, "value", void 0);
exports.SubmitResponse = SubmitResponse;
class SubscribeRequest {
    constructor(args) {
        this.type = msg_1.MessageType.SubscribeRequest;
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
    }
    copy() {
        return new SubscribeRequest(this.asObject());
    }
    asObject() {
        return {
            type: "subscribeRequest",
            partition: this.partition && this.partition,
            account: this.account && this.account.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], SubscribeRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).string
], SubscribeRequest.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 2).url
], SubscribeRequest.prototype, "account", void 0);
exports.SubscribeRequest = SubscribeRequest;
class SubscribeResponse {
    constructor(_) {
        this.type = msg_1.MessageType.SubscribeResponse;
    }
    copy() {
        return new SubscribeResponse(this.asObject());
    }
    asObject() {
        return {
            type: "subscribeResponse",
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], SubscribeResponse.prototype, "type", void 0);
exports.SubscribeResponse = SubscribeResponse;
class ValidateRequest {
    constructor(args) {
        this.type = msg_1.MessageType.ValidateRequest;
        this.envelope =
            args.envelope == undefined
                ? undefined
                : args.envelope instanceof messaging.Envelope
                    ? args.envelope
                    : new messaging.Envelope(args.envelope);
        this.full = args.full == undefined ? undefined : args.full;
    }
    copy() {
        return new ValidateRequest(this.asObject());
    }
    asObject() {
        return {
            type: "validateRequest",
            envelope: this.envelope && this.envelope.asObject(),
            full: this.full && this.full,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], ValidateRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], ValidateRequest.prototype, "envelope", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).bool
], ValidateRequest.prototype, "full", void 0);
exports.ValidateRequest = ValidateRequest;
class ValidateResponse {
    constructor(args) {
        this.type = msg_1.MessageType.ValidateResponse;
        this.value =
            args.value == undefined
                ? undefined
                : args.value.map((v) => v == undefined ? undefined : v instanceof api.Submission ? v : new api.Submission(v));
    }
    copy() {
        return new ValidateResponse(this.asObject());
    }
    asObject() {
        return {
            type: "validateResponse",
            value: this.value && this.value?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(msg_1.MessageType)
], ValidateResponse.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.keepEmpty.reference
], ValidateResponse.prototype, "value", void 0);
exports.ValidateResponse = ValidateResponse;
//# sourceMappingURL=msg_types_gen.js.map